import { GetterTree } from "vuex";
import { IOtherAppointmentState } from "./state";
import { IOtherAppointmentSlot } from "@/models";
import moment from "moment";

export const getters: GetterTree<IOtherAppointmentState, any> = {
    getOtherAppointments: (state) => (): IOtherAppointmentSlot[] => {
        return state.otherApointments;
    },

    getOtherAppointmentByDays: (state) => (day: Date): IOtherAppointmentSlot[] => {
        const notBefore = moment(day);
        const notAfter = moment(day).add(1, "day");
        return state.otherApointments.filter(oa => moment(oa.otherAppointment.date) > notBefore && moment(oa.otherAppointment.date) < notAfter);
    },

    getSelectedOtherAppointment: (state) => (): IOtherAppointmentSlot => {
        return state.selectedOtherAppointment;
    },
};
